import type { FunctionComponent, PropsWithChildren } from 'react';
import { createContext, useContext, useRef } from 'react';
import type { StoreApi } from 'zustand';

import type { AiContextStore } from './ai-context-store';
import { createAiContextStore } from './ai-context-store';

const AiContextStoreContext = createContext<StoreApi<AiContextStore> | null>(null);

export const AiContextProvider: FunctionComponent<PropsWithChildren> = ({ children }) => {
    const storeRef = useRef<StoreApi<AiContextStore> | null>(null);

    if (storeRef.current === null) {
        storeRef.current = createAiContextStore();
    }

    return <AiContextStoreContext.Provider value={storeRef.current}>{children}</AiContextStoreContext.Provider>;
};

export const useAiContextStore = (): StoreApi<AiContextStore> | null => {
    return useContext(AiContextStoreContext);
};
